const prefix = "GAME"

export const JOINED = `${prefix}_JOINED`
export const LOADED = `${prefix}_LOADED`
export const LEFT = `${prefix}_LEFT`
export const SET_TYPE = `${prefix}_SET_TYPE`
export const CREATE = `${prefix}_CREATE`
export const STARTING = `${prefix}_STARTING`
export const START = `${prefix}_START`
export const END = `${prefix}_END`
export const SET_SELECTED = `${prefix}SET_SELECTED`
export const TOGGLE_SELECTED = `${prefix}_TOGGLE_SELECTED`
export const ADD_WORD = `${prefix}_ADD_WORD`
export const CLEAR_SELECTED = `${prefix}_CLEAR_SELECTED`
export const TIMER_TICK = `${prefix}_TIMER_TICK`
export const WORDS_RECEIVED = `${prefix}_WORDS_RECEIVED`